import * as ChartTypes from 'reporting-data/constants/chartTypes';
import { isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { Map as ImmutableMap } from 'immutable';
import { gate } from 'hub-http/gates';
import { getReportChartType } from 'reporting-data/report/reportGetters';
const GAUGE_MIGRATION_GATE = gate('ReportingViz:UnifiedGaugeSFMigration');
const canMigrate = (report, gates) => {
  var _gates$includes;
  const chartType = getReportChartType(report);
  const isCompatibleChartType = chartType === ChartTypes.GAUGE;
  const isUngated = (_gates$includes = gates === null || gates === void 0 ? void 0 : gates.includes(GAUGE_MIGRATION_GATE)) !== null && _gates$includes !== void 0 ? _gates$includes : false;
  return isUngated && isRelationalReport(report) && isCompatibleChartType;
};

/**
 * Transformation Rules:
 * 1. Set `chartType` to `reportDefinition.visual.type`.
 * 2. Set `valueFormattingOptions` to `reportDefinition.visual.encodings.single_value.options.format`.
 * 3. Set 'color' to `reportDefinition.visual.options.color`.
 * 4. Merge all properties from `reportDefinition.visual.options.range` into `chart.layer.plot`, including `max`.
 * 5. Add `showRangeLabels` and `referenceLineValues` from `reportDefinition.visual.options` into `chart.layer`.
 * 6. Add `legendPosition` and `legendWidth` from `reportDefinition.visual.options` into `chart.layer.style`.
 * 7. only for RelationalReport
 * 8. delete `reportDefinition.visual.options`
 */
const migrate = (reportInput, gates) => {
  if (!isRelationalReport(reportInput) || !canMigrate(reportInput, gates)) {
    return reportInput;
  }
  return reportInput.withMutations(map => {
    const reportDefinition = map.get('reportDefinition');
    const visual = reportDefinition.get('visual');
    const options = visual.get('options');
    const chart = ImmutableMap({
      chartType: visual.get('type'),
      color: options.get('color'),
      layer: ImmutableMap({
        plot: ImmutableMap(Object.assign({}, options.get('range').toJS(), {
          bands: options.get('bands')
        })),
        showRangeLabels: options.get('showRangeLabels'),
        referenceLineValues: options.get('referenceLineValues'),
        valueFormattingOptions: ImmutableMap({
          format: visual.getIn(['encodings', 'single_value', 'options', 'format'])
        })
      }),
      style: ImmutableMap({
        legendPosition: options.get('legendPosition'),
        legendWidth: options.get('legendWidth')
      })
    });
    return map.set('chart', chart).deleteIn(['reportDefinition', 'visual', 'options']).deleteIn(['reportDefinition', 'visual', 'encodings', 'single_value', 'options']);
  });
};
export const SnowflakeGaugeMigration = {
  canMigrate,
  migrate
};
export const __TESTABLE__ = {
  GAUGE_MIGRATION_GATE
};